import { SampleFields } from '@app/modules/service-data/components/sample/sample-dialog/field-sets/sample-fields.enum';

export const monoSampleFieldSet = [
  SampleFields.HeparinTherapy,
  SampleFields.HumanSerumAlbuminTherapy,
  SampleFields.CellularImmunotherapy,
  SampleFields.StemCellTherapy,
  SampleFields.TransplantSurgery,
  SampleFields.BloodTransfusion,
  SampleFields.GestationAge,
  SampleFields.UltrasoundDate,
  SampleFields.EditFieldsAvailable,
];
